import React, {useEffect, useState, useMemo} from 'react';
import styles from './UnitModal.module.scss';
import { createPortal } from 'react-dom';
import CloseIcon from '../../../assets/icons/close.svg?react';

type Props = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  global?: boolean;
  noPadding?: boolean;
  closeButton?: boolean;
  className?: string;
  onScroll?: () => void;
  isLoading?: boolean;
  fade?: string;
  fadeAction?: (e: any) => void;
};

const platform = window.navigator.platform;

function PendingModal(props: Props) {
  const { open, onClose, children, global = true, closeButton = true, className = '', noPadding, onScroll, isLoading, fade, fadeAction } = props;
  const [isWindows, setIswindows] = useState(false);
  const [fadeType, setFadeType] = useState("")

  useEffect(() => {
    if (fade) {
      setFadeType(fade)
    }
  }, [fade])

  useEffect(() => {
    if (['Win3', 'Win64', 'Windows', 'Win32', 'Win'].indexOf(platform) !== -1) {
      setIswindows(true);
    }
  }, [])

  const transitionEnd = (e: any) => {
    fadeAction?.(e)
  }

  const handleClose = () => {
    setFadeType('out')
  }

  const totalClass = useMemo(() => {
    const style = [styles.pending];
    
    if (fadeType !== "") {
      style.push(styles[`fade-${fadeType}`]);
    }
    return style.join(' ');
  }, [fadeType])

  const renderContent = (
    <div id='modal-body' className={`${styles.inner} ${className} ${isWindows && styles.innerWindows} ${noPadding && styles.innerOverride} ${isLoading ? styles.loading : ''}`} onScroll={onScroll}>
      {children}
      {closeButton &&
        <button onClick={handleClose} className={styles.closeWrapper}>
          <CloseIcon className={styles.closeIcon}/>
        </button>
      }
    </div>);

  if (!open) return null;

  if (global) {
    return createPortal(
      <div className={totalClass} onTransitionEnd={transitionEnd}>
        <div className={styles.backdrop} onClick={onClose}/>
        {renderContent}
      </div>,
      document.body
    );
  }

  return (
    <div className={styles.local}>
      <div className={styles.backdrop} onClick={onClose}/>
      {renderContent}
    </div>
  )
}

export default PendingModal;
